/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function() {
        // JavaScript to be fired on all pages
      },
      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired
      }
    },
    // Home page
    'home': {
      init: function() {
        // JavaScript to be fired on the home page
      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
      }
    },
    // About us page, note the change from about-us to about_us.
    'about_us': {
      init: function() {
        // JavaScript to be fired on the about us page
      }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.



  //Funzione per la chiusura del banner dei Cookie
  function closeBanner() {
    var element = document.getElementById('cookie-law');
    if(element) {
      element.parentNode.removeChild(element);
      Cookies.set('cookie-banner', '1');
      if(window.onCookieBannerClose) {
        window.onCookieBannerClose();
      }
    }
  }

  //Allo scroll viene chiuso il banner
  window.onscroll = function(){
    closeBanner();
  };

  //Funzione per la creazione del banner
  function createBanner(){
    var bodytag = document.getElementsByTagName('body')[0];
    var div = document.createElement('div');
    div.setAttribute('id', 'cookie-law');
    div.setAttribute('class', 'banner-cookie');
    div.innerHTML = "<div class='banner-cookie-container container'><div class='banner-cookie-text'>Il nostro sito Web utilizza i cookie per assicurarti la migliore esperienza di navigazione. Se desideri maggiori informazioni sui cookie accedi alla nostra <a class='banner-cookie-link' href='http://www.telethon.it/cookie-policy'>Cookie Policy</a></div><button class='banner-cookie-btn' onclick='closeBanner();'>OK</button></div>";
    bodytag.insertBefore(div,bodytag.firstChild);
  }

  // Verifica se il cookie è settato a 1 e in caso contrario crea il banner
  jQuery(window).load(function(){
    if(Cookies){
      var check = Cookies.get('cookie-banner');
      if(check != '1'){
        createBanner();
      }
    }
  });


  dataLayer = [{
    Campaign : dataLayerTransform.campain,
    PageType : dataLayerTransform.page_type
  }];


